module.exports = __webpack_public_path__ + "static/media/default-cover-image.72a93121.svg";